import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const schema = z.object({
    Name: z.string().min(1, "Name is required"),
    Description: z.string().min(1, "Description is required"),
    Email: z
        .string()
        .optional()
        .refine((val) => !val || val === "" || z.string().email().safeParse(val).success, {
            message: "Please enter a valid email address",
        }),
    PhoneNumber: z.string().optional(),
    Address: z.string().optional(),
    City: z.string().optional(),
    Country: z.string().optional(),
    Website: z
        .string()
        .optional()
        .refine((val) => !val || val === "" || z.string().url().safeParse(val).success, {
            message: "Please enter a valid URL",
        }),
    LogoUrl: z.string().optional(),
    Type: z.any().optional(),
});

const newSupplierResolver = zodResolver(schema);

export default newSupplierResolver;
